import { useState } from "react";
import { CalendarCheck, CheckCircle2, Send } from "lucide-react";
import { api } from "../../lib/api";
import { apiErrorMessage } from "../../lib/apiError";

const EMPTY = { company: "", name: "", email: "", phone: "", message: "", consent: false, honeypot: "" };

export function DemoRequestSection() {
  const [form, setForm] = useState(EMPTY);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const update = (field) => (event) =>
    setForm((current) => ({ ...current, [field]: field === "consent" ? event.target.checked : event.target.value }));

  const submit = async (event) => {
    event.preventDefault();
    setError("");
    if (!form.consent) {
      setError("Serve il consenso al trattamento dei dati per poterti ricontattare.");
      return;
    }
    setSending(true);
    try {
      await api.createDemoRequest(form);
      setSent(true);
      setForm(EMPTY);
    } catch (requestError) {
      setError(apiErrorMessage(requestError, "Invio non riuscito: riprova o scrivici a info@toolsvalue.com"));
    } finally {
      setSending(false);
    }
  };

  return (
    <section className="landing-demo" id="demo" data-testid="landing-demo">
      <div className="landing-demo-copy landing-reveal">
        <p className="landing-module-num">DEMO <i /> GUIDATA</p>
        <h2>Mezz'ora, i tuoi codici, la tua officina</h2>
        <p className="landing-desc">
          Ti mostriamo ToolsValue partendo dai tuoi utensili e dalle tue commesse, non da una demo finta.
          Nessun impegno, nessuna carta di credito: alla fine sai se ti serve o no.
        </p>
        <ul className="landing-bullets">
          <li>Analisi gratuita di come gestisci utensili e magazzino oggi</li>
          <li>Configurazione di prova con i tuoi codici di esempio</li>
          <li>Risposta entro un giorno lavorativo</li>
        </ul>
      </div>

      <div className="landing-demo-form landing-reveal">
        {sent ? (
          <div className="demo-sent" data-testid="demo-success">
            <CheckCircle2 size={28} />
            <h3>Richiesta ricevuta</h3>
            <p>Ti ricontattiamo entro un giorno lavorativo all'indirizzo che ci hai indicato. Grazie!</p>
            <button type="button" className="secondary-button" onClick={() => setSent(false)} data-testid="demo-new-request">
              Invia un'altra richiesta
            </button>
          </div>
        ) : (
          <form onSubmit={submit} data-testid="demo-form" noValidate>
            <p className="demo-form-title"><CalendarCheck size={16} /> Richiedi una demo</p>
            <label>
              Azienda *
              <input value={form.company} onChange={update("company")} required minLength={2} maxLength={140} data-testid="demo-company" />
            </label>
            <label>
              Nome e cognome *
              <input value={form.name} onChange={update("name")} required minLength={2} maxLength={120} data-testid="demo-name" />
            </label>
            <label>
              Email *
              <input type="email" value={form.email} onChange={update("email")} required data-testid="demo-email" />
            </label>
            <label>
              Telefono
              <input value={form.phone} onChange={update("phone")} maxLength={40} data-testid="demo-phone" />
            </label>
            <label className="demo-wide">
              Come lavorate oggi? Cosa vorreste risolvere?
              <textarea value={form.message} onChange={update("message")} rows={4} maxLength={2000} data-testid="demo-message" />
            </label>
            <label className="demo-consent demo-wide">
              <input type="checkbox" checked={form.consent} onChange={update("consent")} data-testid="demo-consent" />
              <span>
                Acconsento al trattamento dei dati per essere ricontattato, come indicato nella <a href="/legale/privacy">privacy policy</a>. *
              </span>
            </label>
            <input
              className="demo-honeypot"
              tabIndex={-1}
              autoComplete="off"
              value={form.honeypot}
              onChange={update("honeypot")}
              aria-hidden="true"
            />
            {error && <p className="demo-error demo-wide" data-testid="demo-error">{error}</p>}
            <button type="submit" className="landing-login-btn demo-wide" disabled={sending} data-testid="demo-submit">
              <Send size={15} /> {sending ? "Invio in corso..." : "Invia la richiesta"}
            </button>
          </form>
        )}
      </div>
    </section>
  );
}
